<div class="body">
    <br />
    <div class="row">

        <div class="col-lg-4"> </div>

        <div class="center" *ngIf="data.etapa == 2 || data.etapa == 1">
            <h1> Solicitud de Afiliación Funcionario Activo </h1>
        </div>

        <div class="center" *ngIf="data.etapa == 4">
            <h1> Solicitud de Desafiliación Funcionario Activo </h1>
        </div>


        <div class="col-lg-4"> </div>

    </div>
    <br />

    <div class="container">
        <div class="row">

            <div class="col-lg-2"> </div>
            <div class="col-lg-8"> </div>
            <div class="col-lg-3"> </div>

        </div>


        <br />


        <br />
        <div class="row" *ngIf="data.etapa == 2 || data.etapa == 4">

            <div class="col-lg-2"> </div>

            <div class="col-lg-8">
                <h2> {{data.nombres}} {{data.apellidos}}</h2>
            </div>

            <div class="col-lg-3"> </div>

        </div>

        <br />
        
        <div class="row" *ngIf="data.etapa == 2">

            <div class="col-lg-1"> </div>

            <div class="col-lg-1"> </div>

            <div class="col-lg-8">
                <h2>
                <label>
                Solicitud enviada exitosamente, una ejecutiva revisará los antecedentes y se le comunicará por correo electrónico el estado de esta.
                 </label>
                </h2>
            </div>
            <div class="col-lg-5">
            </div>
        </div>

        <div class="row" *ngIf="data.etapa == 4">

            <div class="col-lg-1"> </div>

            <div class="col-lg-1"> </div>

            <div class="col-lg-8">
                <h2>
                <label>
                Solicitud enviada exitosamente, una ejecutiva revisará los antecedentes.
                 </label>
                </h2>
            </div>
            <div class="col-lg-5">
            </div>
        </div>
        <br />


        <div class="row" *ngIf="data.etapa == 1">

            <div class="col-lg-1"> </div>

            <div class="col-lg-1"> </div>

            <div class="col-lg-8">
                <h2>
                    <label>                
                        No se han logrado validar sus datos con clave única. 
                    </label>                        
                </h2>
                <h2>
                    <label>                
                        Favor revisar que sus datos estén correctos. 
                    </label>                        
                </h2>                
            </div>
            <div class="col-lg-5">
            </div>
        </div>
        <br />

        <div class="row" *ngIf="data.etapa == 0">

            <div class="col-lg-1"> </div>

            <div class="col-lg-1"> </div>

            <div class="col-lg-8">
                <h2>
                <label>                
                    Validando datos
                 </label>
                </h2>
            </div>
            <div class="col-lg-5">
            </div>
        </div>
        <br />

        <div class="row line" *ngIf="data.etapa == 1">

            <div class="col-lg-2 col-sm-2"> </div>

            <div class="col-lg-6 col-sm-1"> </div>

            <div class="col-lg-3 col-sm-1">
                <button class="btn btn-success" (click)="casoFallido()">
                    Aceptar
                </button>
            </div>

            <div class="col-lg-1 col-sm-1"> </div>

        </div>
       
        <div class="row line" *ngIf="data.etapa == 2 || data.etapa == 4">

            <div class="col-lg-2 col-sm-2"> </div>

            <div class="col-lg-6 col-sm-1"> </div>

            <div class="col-lg-3 col-sm-1">
                <button class="btn btn-success" (click)="casoExitoso()">
                    Volver
                </button>
            </div>

            <div class="col-lg-1 col-sm-1"> </div>

        </div>

        

    </div>
</div>

<div class="container" style="height:100px"> </div>